module.exports = __webpack_public_path__ + "static/media/folded-hands.6f8eefaf.png";